"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _style = _interopRequireDefault(require("./style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Container component for registration/password-reset modules,
 * but can be used wherever it fits.
 */

const PageContainer = _ref => {
  let {
    children,
    maxWidth = 600,
    ...props
  } = _ref;
  const classes = (0, _style.default)(props);
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    component: _core.Container,
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    mx: "auto",
    maxWidth: maxWidth
  }, children));
};
var _default = exports.default = PageContainer;